import { graphql, useStaticQuery } from 'gatsby'
import {
  CategoriesQueryQuery,
  PrismicFaqCategory,
} from 'src/typings/generated/graphql'

/**
 * Provides a list of all the FAQ categories available in the Prismic CMS, sorted by title in ascending order.
 */
export const useFaqCategories = () => {
  const faqCategoriesQuery: CategoriesQueryQuery = useStaticQuery(graphql`
    query CategoriesQuery {
      allPrismicFaqCategory(sort: { data: { title: { text: ASC } } }) {
        nodes {
          id
          data {
            title {
              text
            }
            question_and_answer {
              question {
                text
              }
              answer {
                richText
              }
            }
          }
        }
      }
    }
  `)

  const faqCategories = faqCategoriesQuery.allPrismicFaqCategory
    .nodes as PrismicFaqCategory[]

  return faqCategories
}
